import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getScattergramData = ({ schoolId, params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/historical/scattergram/${schoolId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getHistoricalRecords = ({ schoolId, params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/historical/scattergram/${schoolId}/historical-records/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getHistoricalRecordsFilterContext = ({
  version = 'v1',
  schoolId,
  params,
}) =>
  client
    .request({
      url: `${version}/historical/scattergram/${schoolId}/historical-records/filter-context/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getApplicationRecord = ({ id, params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/historical/application-records/${id}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getScattergramCounts = ({ params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/historical/application-records/counts/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getApplicationRecordExistence = ({ params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/historical/application-records-exist/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
